import { forwardRef } from "react";
import { Button } from "antd";
import classNames from "classnames";
import type { ButtonProps } from "antd/lib/button";
import styles from "./styles.module.scss";

export type AppButtonProps = {
  isOutlined?: boolean;
} & ButtonProps;

export const AppButton = forwardRef<HTMLButtonElement, AppButtonProps>(
  ({ className, isOutlined, children, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={classNames(styles.button, { [styles.outlined]: isOutlined }, className)}
        {...props}
      >
        {children}
      </Button>
    );
  },
);
